import { createContext } from 'react';
import {
  Product,
  GuestUserContextType,
  ChildrenType,
} from '../interface/interface';
import { getGuestAccessories } from '../service/getGuestAccessories';
import { GuestCartProvider } from './guestCartContext';
import { useQuery } from '@tanstack/react-query';

const GuestUserContext = createContext({} as GuestUserContextType);

const GuestUserContextProvider = ({ children }: ChildrenType) => {
  const fetchGuestAccessories = async (): Promise<Product[]> => {
    const res = await getGuestAccessories();
    if (typeof res === 'number') {
      return [];
    }
    return res ?? [];
  };

  const { data: guestSearchProducts = [], isLoading: loading } = useQuery({
    queryKey: ['guest-accessories'],
    queryFn: fetchGuestAccessories,
  });

  return (
    <GuestCartProvider>
      <GuestUserContext.Provider value={{ guestSearchProducts, loading }}>
        {children}
      </GuestUserContext.Provider>
    </GuestCartProvider>
  );
};

export { GuestUserContext, GuestUserContextProvider };
